//Tipo de interfaz
export enum TypeAccountingSystemEnums {
    cxc = 1,
    contab = 2,
}

//Intefaces
export enum AccountingSystemEnums {
    ilimitada = 1,
    megasistemas = 2,
    siigo = 3,
    siesa = 4,
    psl = 5,
    helisa = 6,
    delta_M = 7,
    worldOffice = 8,
    delta_E = 9,
    sap = 10,
    gral_Ledger = 11,
    milenium = 12,
    megasistemasWeb = 13,
    siesaCloud = 18,
}